export default "__VITE_ASSET__MrH3mVyX__"